import React from 'react'
import { LogoBorder } from '../../assets/icons'
import HowCard from './HowCard/HowCard'

import style from './HowEcoTienda.module.css'
const HowEcoTienda = () => {
    return (
        <div>
            <div className={`row centerItems centerContent mt-2`}>

                <LogoBorder height={200} className="icon-border-login-view" />
                <div className={style.title}>
                    <span className={style.titleH}>Eco</span>ideas
                </div>

            </div>

            <div className={style.title}>
                <span className={style.titleH}>¿Como</span> ser EcoTienda?
            </div>

            <div className={style.steeps}>
                <HowCard
                    steep={"1"}
                    text={"Verifica tu cuenta"}
                />
                <HowCard
                    steep={"2"}
                    text={"Llena el formulario de solicitud de Ecotienda"}
                />
                <HowCard
                    steep={"3"}
                    text={"Carga los soportes"}
                />
                <HowCard
                    steep={"4"}
                    text={"Genera la solicitud"}
                />
                <HowCard
                    steep={"5"}
                    text={"Espera la aprobación"}
                />
            </div>
            <div className={style.title}>
                ¿<span className={style.titleH}>¡Sé </span> parte de Ecoideas y obtén grandes beneficios!
            </div>
            <div className={style.info_card_container}>
                <div className={style.info_card}>Podrás comprar productos de Ecoideas a un <strong>precio ESPECIAL</strong></div>
                <div className={style.info_card}><strong>Obtendrás puntos</strong> por compras y el registro de la Ecotienda</div>
            </div>
        </div>
    )
}

export default HowEcoTienda